export const waitingExaminationZh = {
  step: {
    IdentityVerification: '身份核验',
    MobilePhone: '手机监考',
    ComputerScreen: '电脑屏幕监考',
    ComputerCamera: '摄像头监考',
    CameraAndMicrophone: '摄像头与麦克风监考'
  },
  ComputerScreen: {
    desc: '本场考试已开启电脑屏幕监考，请共享你的电脑屏幕',
    windows: {
      desc1: '请在弹窗中选择整个屏幕标签，并选中共享的考试屏幕',
      desc2: '为避免切屏，请在开始答题前隐藏共享屏幕的浮窗'
    },
    mac: {
      desc3: '若Mac系统无法弹出共享屏幕，请检查',
      desc3L: '系统屏幕录制权限'
    },
    ShareScreen: '共享屏幕',
    shareScreenImg: 'https://img.webloom.cn/img/newShareScreenImgZH.png',
    Connecting: '连接中'
  },
  ComputerCamera: {
    desc1: '本场考试已开启摄像头监考，系统将开启你的摄像头',
    desc2: '若开启失败，请点击下方按钮重启摄像头',
    desc3: '本场考试已开启摄像头和麦克风监考，系统将开启你的摄像头和麦克风',
    desc4: '若开启失败，请点击下方按钮重启摄像头和麦克风',
    next: '已开启，下一步',
    reAccess: '重启摄像头',
    reAccess1: '重启摄像头和麦克风'
  },
  speakToStudent: {
    willSpeak: '监考员将与你语音连线',
    connecting: '连线中…',
    hangUp: '已挂断'
  },
  invigilationList: {
    InvigilationNotice: '监考通知',
    Rrefresh: '刷新',
    invigilator: '因你的监考设备出现异常，组委会已在系统后台为你调整监考设置，请刷新页面重新进入考试（不会计为违规）。组委会将加强对你的关注，请严格遵守考试规则！'
  }
}
export const waitingExaminationEn = {
  step: {
    IdentityVerification: 'Identity Verification',
    MobilePhone: 'Mobile Phone',
    ComputerScreen: 'Computer Screen',
    ComputerCamera: 'Computer Camera',
    CameraAndMicrophone: 'Computer Camera and Microphone'
  },
  ComputerScreen: {
    desc: 'Please share your computer screen to enter the test.',
    windows: {
      desc1: 'Select the [Entire Screen] TAB in the pop-up window and [Select] the screen you want to share',
      desc2: 'To avoid the screen switching warning, please [Hide] the floating window before entering the test.'
    },
    mac: {
      desc3: 'If it fails on Mac, check the ',
      desc3L: 'system screen recording permission.'
    },
    ShareScreen: 'Share screen',
    shareScreenImg: 'https://img.webloom.cn/img/newShareScreenImgEN.png',
    Connecting: 'Connecting'
  },
  ComputerCamera: {
    desc1: 'We will access to your computer camera for invigilation.',
    desc2: 'If it failed, click the button below to re-access the camera.',
    desc3: 'We will access to your camera and microphone for invigilation.',
    desc4: 'If it failed, click the button below to re-access camera and microphone.',
    next: 'Accessed, next',
    reAccess: 'Re-access camera',
    reAccess1: 'Re-access camera and microphone'
  },
  speakToStudent: {
    willSpeak: 'The invigilator will speak to you in',
    connecting: 'Connecting...',
    hangUp: 'Hang up'
  },
  invigilationList: {
    InvigilationNotice: 'Invigilation notice',
    Rrefresh: 'Rrefresh',
    invigilator: 'Because your invigilator device runs abnormal, the organizing committee has adjusted the invigilation settings for you, please refresh the page to re-enter the test (it would not be regarded as violation) . The organizing committee will pay closer attention to you,  please abide by the test rules strictly.'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/waitingExamination.js